class HelpController {

    constructor() {
        this.view = new HelpView();
        this.view.helpBtn.click(this.open.bind(this));
        this.view.nextTipButton.click(this.nextTip.bind(this));
        this.view.doneButton.click(this.close.bind(this));
        this.tipNo = 1;
    }

    open() {
        this.tipNo = 1;
        this.view.open();
    }

    nextTip() {
        this.tipNo += 1;
        this.view.showTip(this.tipNo, true);
    }

    close() {
        this.view.close();
    }

    showHelpIfRequired() {
        let helpShown = Cookies.get('studyPlanner_helpShown', null);
        if(helpShown == null) {
            this.open();
            Cookies.set('studyPlanner_helpShown', true, {path: '/', expires: 365});
        }
    }
}
